// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDOAxhQx8chTxZOs6vE8teRkLstwTfqToc',
    authDomain: 'asips-3efdd.firebaseapp.com',
    databaseURL: 'https://asips-3efdd-default-rtdb.firebaseio.com',
    projectId: 'asips-3efdd',
    storageBucket: 'asips-3efdd.appspot.com',
    messagingSenderId: '595901833557',
    appId: '1:595901833557:web:d7c009c33b26758b240fdc'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
